/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { hiddenMcpServersHide } from "../funcs/hiddenMcpServersHide.js";
import { hiddenMcpServersList } from "../funcs/hiddenMcpServersList.js";
import { hiddenMcpServersUnhide } from "../funcs/hiddenMcpServersUnhide.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListHiddenMcpServersResult } from "../models/components/listhiddenmcpserversresult.js";
import {
  HideMcpServerRequest,
  HideMcpServerSecurity,
} from "../models/operations/hidemcpserver.js";
import {
  ListHiddenMcpServersRequest,
  ListHiddenMcpServersSecurity,
} from "../models/operations/listhiddenmcpservers.js";
import {
  UnhideMcpServerRequest,
  UnhideMcpServerSecurity,
} from "../models/operations/unhidemcpserver.js";
import { unwrapAsync } from "../types/fp.js";

export class HiddenMcpServers extends ClientSDK {
  /**
   * hide hiddenMcpServers
   *
   * @remarks
   * Hide an MCP server for the signed-in user. Hiding a hidden server changes nothing.
   */
  async hide(
    request: HideMcpServerRequest,
    security?: HideMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hiddenMcpServersHide(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list hiddenMcpServers
   *
   * @remarks
   * List the MCP servers the signed-in user hid in the active organization.
   */
  async list(
    request?: ListHiddenMcpServersRequest | undefined,
    security?: ListHiddenMcpServersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListHiddenMcpServersResult> {
    return unwrapAsync(hiddenMcpServersList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * unhide hiddenMcpServers
   *
   * @remarks
   * Show a hidden MCP server again for the signed-in user. Unhiding a server that is not hidden changes nothing.
   */
  async unhide(
    request: UnhideMcpServerRequest,
    security?: UnhideMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hiddenMcpServersUnhide(
      this,
      request,
      security,
      options,
    ));
  }
}
